import WillWizard from "@/components/wizard/WillWizard";

export default function WillGenerator() {
  return (
    <div data-testid="will-generator-page">
      <section className="bg-navy py-14 text-white sm:py-16">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
            Essential Will – ₹99
          </div>
          <h1 className="mt-3 font-serif text-3xl leading-tight sm:text-5xl">
            Create your will in 10 minutes.
          </h1>
          <p className="mt-4 max-w-2xl text-sm text-white/75 sm:text-base">
            Step-by-step guidance. Professionally structured under the Indian Succession
            Act, 1925 using our guided legal will builder. Pay only when your draft is ready.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-5 py-10 sm:px-8 sm:py-14">
        <WillWizard mode="single" />
      </section>
    </div>
  );
}
